import { styled } from "../../../styled-components";
import { ImageAspectRatio, ImageFitStyle } from "common/generator/components/image-types";

function sizeToPadding(size: ImageAspectRatio) {
    switch (size) {
        case ImageAspectRatio.FourByThree:
            return "133%";
        case ImageAspectRatio.Square:
            return "100%";
        case ImageAspectRatio.ThreeByTwo:
            return "66.7%";
        case ImageAspectRatio.ThreeByOne:
            return "33.3%";
        default:
            return "0";
    }
}

interface Props {
    size: ImageAspectRatio;
    fitStyle: ImageFitStyle;
}
export const CarouselViewStyle = styled.div<Props>`
    position: relative;
    padding-bottom: ${p => sizeToPadding(p.size)};
    overflow: hidden;

    > .scroller {
        display: flex;
        align-items: center;
        position: ${p => (p.size === ImageAspectRatio.Fit ? "block" : "absolute")};
        left: 0;
        top: 0;
        width: 100%;
        height: ${p => (p.size === ImageAspectRatio.Fit ? "unset" : "100%")};

        > * {
            width: 100%;
            height: ${p => (p.size === ImageAspectRatio.Fit ? "unset" : "100%")};
            flex-shrink: 0;
        }
    }

    @keyframes cvs-tag-fade-out {
        0% {
            opacity: 0.6;
        }
        50% {
            opacity: 0.6;
        }
        100% {
            opacity: 0;
        }
    }

    > .tag {
        position: absolute;
        left: 50%;
        bottom: 20px;
        border-radius: 100px;
        padding: 6px 12px;
        ${p => p.theme.fontStyles.AccentHeader4}

        color: white;
        background: black;
        opacity: 0;

        pointer-events: none;
        transform: translateX(-50%);

        animation: cvs-tag-fade-out 1300ms 1 ease-in;
    }
`;
